export default __webpack_public_path__ + "static/media/ITOPM.3fb6af43.svg";